module.exports = __webpack_public_path__ + "img/product-goshawk-u8-rgb.cca642c8.png";